import dishesin from "../data/Dishes";
const dishState = {
  dishes: dishesin,
};

const reducer = (state = dishState, action) => {
  return state;
};
export { reducer };
